import { ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import { app, App } from '@df/core/app';
import defaults from 'lodash-es/defaults';
import { ICmsNotificationAreaComponent } from './area/icms-notification-area.component';
import { NICmsNotification } from './icms-notification.interfaces';

declare module '@df/core/app' {
    interface App {
        iCmsNotificationService: ICmsNotificationService;
    }
}

@Injectable()
export class ICmsNotificationService {
    /**
     * Notification area component ref
     */
    private areaRef?: ComponentRef<ICmsNotificationAreaComponent>;

    constructor(app: App, private injector: Injector, private componentFactoryResolver: ComponentFactoryResolver) {
        app.iCmsNotificationService = this;
    }

    add(notification: NICmsNotification.IData) {
        this.createArea();
        if (this.areaRef) {
            this.areaRef.instance.add(defaults(notification, { duration: 3000 }));
        }
    }

    toErrorMsg(err: Error | string | null | undefined | any): string {
        app.logger.error(err);
        const error = err && typeof err === 'object' ? err.message || err.error : err;
        return typeof error === 'string' ? error : 'Unexpected error';
    }

    createArea() {
        if (!this.areaRef) {
            this.areaRef = this.componentFactoryResolver.resolveComponentFactory(ICmsNotificationAreaComponent).create(this.injector);
            const domElem = (this.areaRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
            document.body.appendChild(domElem);
            this.areaRef.onDestroy(() => {
                this.areaRef = undefined;
            });
            this.areaRef.changeDetectorRef.detectChanges();
        }
    }

    // removeArea() {
    //     const domElem = (this.areaRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    //     domElem.remove()
    //     this.areaRef = undefined
    // }
}
